import React, { memo, useEffect } from "react";

import ReadAloud from "components/Question/Speaking/ReadAloud.jsx";
import RepeatSentece from "components/Question/Speaking/RepeatSentece.jsx";
import DescribeImage from "components/Question/Speaking/DescribeImage.jsx";
import RetellLec from "components/Question/Speaking/RetellLec.jsx";
import ShortQue from "components/Question/Speaking/ShortQue.jsx";
import RespondToSituation from "components/Question/Speaking/New/RespondToSituation.jsx";
import SummarizeGroupDiscussion from "components/Question/Speaking/New/SummarizeGroupDiscussion.jsx";

import SummarizeWrittenText from "components/Question/Writting/Summary.jsx";
import WriteEssay from "components/Question/Writting/Essay.jsx";

import ReadingMCQSingleAnswer from "components/Question/Reading/SingleAnswer.jsx";
import ReadingMCQMultipleAnswer from "components/Question/Reading/MultipleAnswer.jsx";
import Reorder from "components/Question/Reading/Reorder1.jsx";
import ReadingBlank from "components/Question/Reading/ReadingBlank.jsx";
import ReadingAndWritingBlank from "components/Question/Reading/WrittingBlank.jsx";

import SummerizeSpoken from "components/Question/Listening/Summer.jsx";
import ListeningMcqSingle from "components/Question/Listening/McqSingle.jsx";
import ListeningMcqMulti from "components/Question/Listening/McqMulti.jsx";
import ListeningFillInTheBlank from "components/Question/Listening/ListeningBlank.jsx";
import CorrectSummary from "components/Question/Listening/CorrectSummary.jsx";
import MissingWord from "components/Question/Listening/MissingWord.jsx";
import Highlight from "components/Question/Listening/Highlight.jsx";
import Dictation from "components/Question/Listening/Dictation.jsx";

const CurrentQuestion = memo(function ({
	subcategoryId, props_data
}) {

	const selectedQuestion = () => {
		let question = "";
		
		switch (subcategoryId) {
			case 1:
				question = <ReadAloud {...props_data} />;
				break;
			case 2:
				question = <RepeatSentece {...props_data} />;
				break;
			case 3:
				question = <DescribeImage {...props_data} />;
				break;
			case 4:
				question = <RetellLec {...props_data} />;
				break;
			case 5:
				question = <ShortQue {...props_data} />;
				break;
			case 21:
				question = <RespondToSituation {...props_data} />;
				break;
			case 22:
				question = <SummarizeGroupDiscussion {...props_data} />;
				break;
			case 6:
				question = <SummarizeWrittenText {...props_data} />;
				break;
			case 7:
				question = <WriteEssay {...props_data} />;
				break;
			case 8:
				question = <ReadingMCQSingleAnswer {...props_data} />;
				break;
			case 9:
				question = <ReadingMCQMultipleAnswer {...props_data} />;
				break;
			case 10:
				question = <Reorder {...props_data} />;
				break;
			case 11:
				question = <ReadingBlank {...props_data} />;
				break;
			case 12:
				question = <ReadingAndWritingBlank {...props_data} />;
				break;
			case 13:
				question = <SummerizeSpoken {...props_data} />;
				break;
			case 14:
				question = <ListeningMcqSingle {...props_data} />;
				break;
			case 15:
				question = <ListeningMcqMulti {...props_data} />;
				break;
			case 16:
				question = <ListeningFillInTheBlank {...props_data} />;
				break;
			case 17:
				question = <CorrectSummary {...props_data} />;
				break;
			case 18:
				question = <MissingWord {...props_data} />;
				break;
			case 19:
				question = <Highlight {...props_data} />;
				break;
			case 20:
				question = <Dictation {...props_data} />;
				break;
			default:
				// do nothing.
		}

		return question;
	};

	return selectedQuestion();
});

export default CurrentQuestion;